import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Next_logo.svg'


const _hoisted_1 = { class: "hidden h-next-top bg-white lg:flex items-center justify-between max-w-screen-2xl m-auto" }
const _hoisted_2 = { class: "basis-1/2 flex items-center justify-center relative" }
const _hoisted_3 = { class: "lg:hidden bg-white" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "flex justify-between pb-5" }
const _hoisted_6 = { class: "min-w-0 flex items-center justify-center relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CercaModal = _resolveComponent("CercaModal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (_ctx.cercaModalVisibility)
        ? (_openBlock(), _createBlock(_component_CercaModal, {
            key: 0,
            onReject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cercaModalVisibility = false)),
            onConfirm: _ctx.cerca
          }, null, 8, ["onConfirm"]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: {name:'Home'} }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "h-12"
          }, null, -1)
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("i", { class: "icon-lente absolute left-0 ml-3" }, null, -1)),
        _withDirectives(_createElementVNode("input", {
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.cerca({text:_ctx.search})), ["enter"])),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
          class: "flex-grow bg-next-light-gray p-2 pl-10",
          placeholder: "Cerca"
        }, null, 544), [
          [_vModelText, _ctx.search]
        ]),
        _createElementVNode("i", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cercaModalVisibility = !_ctx.cercaModalVisibility)),
          class: "pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[9] || (_cache[9] = _createElementVNode("img", {
          src: _imports_0,
          class: "py-3",
          style: {"height":"75px"}
        }, null, -1)),
        _createElementVNode("i", {
          class: "icon-filtri self-center text-3xl",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("i", { class: "icon-lente absolute left-0 ml-3" }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.cerca({text:_ctx.search})), ["enter"])),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.search) = $event)),
            class: "self-stretch min-w-0 bg-next-light-gray p-2 pl-10",
            placeholder: "Cerca"
          }, null, 544), [
            [_vModelText, _ctx.search]
          ])
        ])
      ])
    ])
  ], 64))
}